/**
 * @author NikolaV
 */

import * as React from 'react';
import { observer } from 'mobx-react';
import { Dropdown } from '@shared/ui-react/Dropdown';
import { BackgroundMaps } from '@openlayers/BackgroundMaps';


@observer
export class BgMapsPanelToolbar extends React.Component<{
    layer: BackgroundMaps
}> {
    render() {
        const opacity = this.props.layer.layerOpacity;

        return (
            <>
                <span style={{ marginLeft: 'auto' }}>
                    <Dropdown closeOnBodyClick={false} buttonStyle={{ paddingLeft: 10, paddingRight: 10 }} className='ik-button-secondary--subtle'>
                        <i className='iki iki-more'/>
                        <div>
                            <div className='dropdown-list-title'>{__('js_map.layer_opacity')}:</div>
                            <div className='flex-row padded-half ai-center'>
                                <input type='range' min={20} max={100} step={10} value={opacity}
                                       onChange={e => this.props.layer.layerOpacity = parseInt(e.currentTarget.value)}/>
                                <strong style={{ width: '3em' }}> {opacity}%</strong>
                            </div>
                        </div>
                    </Dropdown>
                </span>
            </>
        );
    }
}
